import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

/**
 * Transform date into D/M/Y format
 * Using Moment.js. Please, see more information here https://momentjs.com/
 * @param date - string ("2019-08-22 00:00:00.0")
 * @returns string ("22/8/2019")
 */
@Pipe({
  name: 'normalizeDate'
})
export class NormalizeDatePipe implements PipeTransform {

  transform(date: string): string {
    return date ? moment(date).format('D/M/Y') : '-';
  }

}
